// Flag banner name type for better type safety
export type FlagBannerNameType = string

// Map game names to country background flags
export const gameNameGroups: Record<string, string[]> = {
  // Thailand
  thailand: [
    'thai-afternoon-stock',
    'thai-morning-stock',
    'thai-stock-evening',
    'thai-stock-pm',
    'thai-government-lotto',
    'government-set-lottery',
    'thai-government-lotto-set',
    'thai-government-bank-lotto',
    'thai-government-bank-lotto-set',
  ],
  // China
  china: ['china-afternoon-stock', 'china-morning-stock'],
  // Hong Kong (Hang Seng)
  hangseng: ['hangseng-afternoon-stock', 'hangseng-morning-stock', 'hangseng'],
  // Japan
  japan: ['japan-lotto', 'nikkei-afternoon-stock', 'nikkei-morning-stock'],
  // Korea
  korea: ['korea-stock'],
  // Laos
  laos: [
    'lao-star-stock',
    'laos-group-set-banner-flag',
    'laostar',
    'laos-lotto',
  ],
  // Malaysia
  malaysia: ['malaysia-lotto', 'malaysia-stock'],
  // Vietnam
  vietnam: ['hanoi', 'vietnam-lotto'],
  'hanoi-vip': ['hanoi-vip'],
  'hanoi-special': ['hanoi-special'],
  // Singapore
  singapore: ['singapore-stock'],
  // India
  india: ['india-lotto'],
  // Germany
  germany: ['german-stock'],
  // Russia
  russia: ['russia-stock'],
  // Egypt
  egypt: ['egypt-stock'],
  // England (UK)
  england: ['england-stock'],
  // USA
  usa: ['usa-stock', 'dowjones-stock'],
  // Taiwan
  taiwan: ['taiwan-stock'],
  // Separate (standalone)
  baac: ['baac-lotto'],
  aomsin: ['aomsin-lotto'],
  gsb: ['government-savings-bank'],
  crypto: ['crypto'],
  stock: ['stock'],
  malta: ['yeekee-malta'],
  'yeekee-vip': ['yeekeeVIP'],
  yeekee: ['yeekee'],
}

/**
 * Maps a game name to its corresponding background flag group
 * @param gameName The name of the game to map
 * @returns The background flag group name, or the original name if not found
 */
export function getBackgroundFlagGroup(
  flagBannerName: FlagBannerNameType,
): string {
  if (!flagBannerName) return 'stock' // Default fallback

  // Check if the name is already a direct country/group name
  if (gameNameGroups[flagBannerName]) {
    return flagBannerName
  }

  // Find which country group this game name belongs to
  for (const [country, gameNames] of Object.entries(gameNameGroups)) {
    if (gameNames.includes(flagBannerName)) {
      return country
    }
  }

  // If no match found, return the original name
  return flagBannerName
}
